import { CmcdHeaderField } from './CmcdHeaderField.js';
import { CmcdHeaderMap } from './CmcdHeaderMap.js';
import { encodeCmcd } from './encodeCmcd.js';
/**
 * Convert a CMCD data object to request headers
 *
 * @param cmcd - The CMCD data object to convert.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The CMCD header shards.
 *
 * @group CMCD
 *
 * @beta
 */
export function toCmcdHeaders(cmcd, options = {}) {
    if (!cmcd) {
        return {};
    }
    const entries = Object.entries(cmcd);
    const headerMap = Object.entries(CmcdHeaderMap)
        .concat(Object.entries(options?.customHeaderMap || {}));
    const shards = entries.reduce((acc, entry) => {
        const [key, value] = entry;
        const field = headerMap.find(entry => entry[1].includes(key))?.[0] || CmcdHeaderField.REQUEST;
        acc[field] ??= {};
        acc[field][key] = value;
        return acc;
    }, {});
    return Object.entries(shards)
        .reduce((acc, [field, value]) => {
        acc[field] = encodeCmcd(value, options);
        return acc;
    }, {});
}
//# sourceMappingURL=toCmcdHeaders.js.map